import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Subject } from 'rxjs';
import { ApiCallService } from 'src/app/core/services/api-call.service';
import { ManoDeObra } from 'src/app/shared/models/mano-de-obra';
import { DetalleManoDeObraComponent } from '../detalle-mano-de-obra/detalle-mano-de-obra.component';
import { takeUntil } from 'rxjs/operators';
import { HelperClassService } from 'src/app/core/services/clase-utilidades.services';
import { Constanst } from 'src/app/core/constants/constans.component';

@Component({
  selector: 'app-gestion-mano-de-obra',
  templateUrl: './gestion-mano-de-obra.component.html',
  styleUrls: ['./gestion-mano-de-obra.component.css']
})
export class GestionManoDeObraComponent implements OnInit {

  displayedColumns: string[] = ['reference', 'updateDate', 'description', 'jornal', 'price', 'addedValue',
    'laborGrouping', 'dollarPrice', 'commentary'];

  filterColumForm = new FormGroup({
    filterDetails: new FormControl('0'),
    descriptionFilter: new FormControl('', [Validators.minLength(3), Validators.maxLength(100)]),
  });
  filterSearchForm = new FormGroup({
    descriptionSearch: new FormControl('', [Validators.minLength(3), Validators.maxLength(100)]),
  });
  clickedRows = new Set<ManoDeObra>();
  filterNoSelected: boolean = false;
  messageError: string;
  filterDictionary = new Map<string | null, string | null>();
  private method: string;
  private route: string;
  private destroy$: Subject<boolean> = new Subject<boolean>();

  experiencia: string;
  conocimientos: string;
  tareas: string;

  dataSource = new MatTableDataSource<ManoDeObra>;
  dataSourceFilters = new MatTableDataSource<ManoDeObra>;

  @ViewChild('paginator') paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  totalItemsPage: number;
  dataListManoDeObra: ManoDeObra[];
  disableButtonfilter: boolean = true;
  disableButtonSearch: boolean = false;
  typeAction: string;
  defaultFilterDetails = 'description';
  classFlag: boolean = false;

  constructor(
    public dialogDetalleManoDeObra: MatDialog,
    private apiCallService: ApiCallService,
    private helperClassService: HelperClassService,
  ) {}

  ngOnInit(): void {
    this.classFlag = this.helperClassService.validateViewMobileScreen(screen.width);
    this.filterColumForm.get('filterDetails')!.setValue(this.defaultFilterDetails);
    this.getAllLabor();
    this.cleanFilter();
  }

  ngAfterViewInit() {
    this.dataSourceFilters.paginator = this.paginator;
    this.paginator.page.subscribe(() => {
      if (this.typeAction == 'filterColum') {
        this.applyFilterDetails();
      } else if (this.typeAction == 'filterSearch') {
        this.applyFilter();
      } else {
        this.getAllLabor();
      }
    });
    this.dataSourceFilters.sort = this.sort;
  }

  applyFilterDetails() {
    if (this.filterColumForm.invalid) {
      return;
    } else {
      this.typeAction = 'filterColum';
      let typeSearchValue = -1;
      let filterValue = this.filterColumForm.controls['descriptionFilter'].value;
      if (filterValue?.trim() != '') {
        let listFilterValue = filterValue?.trim().split(/\s/);
        if (listFilterValue?.length! <= 5) {
          let typeSearch = this.filterColumForm.controls['filterDetails'].value;
          if (typeSearch === 'laborGrouping') { typeSearchValue = 0 }
          if (typeSearch === 'description') { typeSearchValue = 1 }
          if (typeSearch === 'reference') { typeSearchValue = 2 }

          this.route = '/getAllLaborCustomizedPage';
          this.method = 'POST';
          let data = {
            idTypeLabor: 1,
            year: Number(localStorage.getItem(Constanst.STORAGE_DATA_ANIOCONSULT) ? localStorage.getItem(Constanst.STORAGE_DATA_ANIOCONSULT) : new Date().getFullYear()),
            month: Number(localStorage.getItem(Constanst.STORAGE_DATA_MONTHCONSULT) ? Number(localStorage.getItem(Constanst.STORAGE_DATA_MONTHCONSULT)) : (new Date().getMonth() + 1)),
            page: (this.paginator ? (this.paginator.pageIndex) : 0),
            pageSize: (this.paginator ? this.paginator.pageSize : 25),
            typeSearchLabor: typeSearchValue,
            searchLabor: filterValue?.trim()
          }

          this.apiCallService.call$(data, this.route, this.method, true, '', true)
            .pipe(takeUntil(this.destroy$)).subscribe(response => {
              if (response.status === Constanst.RESPONSE_STATUS_SUCCESS) {
                this.totalItemsPage = response.data.total;
                this.dataListManoDeObra = response.data.content;
                this.dataSourceFilters = new MatTableDataSource(this.dataListManoDeObra);
              } else {
                this.helperClassService.openDialogGeneric('25rem', true, Constanst.MSG_GENERIC_ERROR, false, true, false, '', '', '', Constanst.DIALOG_RESULT_ERROR);
              }
              this.apiCallService.hideSpinner();
            });
        } else {
          this.helperClassService.openDialogGeneric('25rem', true, Constanst.MSG_FILTER_SEARCH_LIMIT, false, true, false, '', '', '', Constanst.DIALOG_RESULT_INFO);
        }
      } else {
        this.helperClassService.openDialogGeneric('25rem', true, Constanst.MSG_VALUE_EMPTY, false, true, false, '', '', '', Constanst.DIALOG_RESULT_INFO);
      }
    }
  }

  applyFilter() {
    if (this.filterSearchForm.invalid) {
      return;
    } else {
      this.typeAction = 'filterSearch';
      let filterValue = this.filterSearchForm.controls['descriptionSearch'].value;
      if (filterValue?.trim() != '') {
        let listFilterValue = filterValue?.trim().split(/\s/);
        if (listFilterValue?.length! <= 5) {
          this.route = '/getAllLaborGeneralPage';
          this.method = 'POST';
          let data = {
            idTypeLabor: 1,
            year: Number(localStorage.getItem(Constanst.STORAGE_DATA_ANIOCONSULT) ? localStorage.getItem(Constanst.STORAGE_DATA_ANIOCONSULT) : new Date().getFullYear()),
            month: Number(localStorage.getItem(Constanst.STORAGE_DATA_MONTHCONSULT) ? Number(localStorage.getItem(Constanst.STORAGE_DATA_MONTHCONSULT)) : (new Date().getMonth() + 1)),
            page: (this.paginator ? (this.paginator.pageIndex) : 0),
            pageSize: (this.paginator ? this.paginator.pageSize : 25),
            searchLabor: filterValue?.trim()
          }

          this.apiCallService.call$(data, this.route, this.method, true, '', true)
            .pipe(takeUntil(this.destroy$)).subscribe(response => {
              if (response.status === Constanst.RESPONSE_STATUS_SUCCESS) {
                this.totalItemsPage = response.data.total;
                this.dataListManoDeObra = response.data.content;
                this.dataSourceFilters = new MatTableDataSource(this.dataListManoDeObra);
              } else {
                this.helperClassService.openDialogGeneric('25rem', true, Constanst.MSG_GENERIC_ERROR, false, true, false, '', '', '', Constanst.DIALOG_RESULT_ERROR);
              }
              this.apiCallService.hideSpinner();
            });
        } else {
          this.helperClassService.openDialogGeneric('25rem', true, Constanst.MSG_FILTER_SEARCH_LIMIT, false, true, false, '', '', '', Constanst.DIALOG_RESULT_INFO);
        }
      } else {
        this.helperClassService.openDialogGeneric('25rem', true, Constanst.MSG_VALUE_EMPTY, false, true, false, '', '', '', Constanst.DIALOG_RESULT_INFO);
      }
    }
  }

  verDetalle(row: ManoDeObra) {
    this.dialogDetalleManoDeObra.open(DetalleManoDeObraComponent, {
      width: '100%',
      maxWidth: '100%',
      height: '100%',
      // disableClose: true,
      data: { row, nroRegistro: this.totalItemsPage, simple: true, dialogTitle: 'Mano de Obra Simple' }
    });
  }

  cleanFilter() {
    this.filterColumForm.get('descriptionFilter')?.setValue('');
    this.filterSearchForm.get('descriptionSearch')?.setValue('');
    if (this.filterColumForm.get('filterDetails')?.value === '0') {
      this.filterColumForm.get('descriptionFilter')?.disable();
      this.disableButtonfilter = true;
      this.filterSearchForm.get('descriptionSearch')?.enable();
      this.disableButtonSearch = false;
      this.paginator.pageIndex = 0;
      this.getAllLabor();
    } else {
      this.filterColumForm.get('descriptionFilter')?.enable();
      this.disableButtonfilter = false;
      this.filterSearchForm.get('descriptionSearch')?.disable();
      this.disableButtonSearch = true;
    }
  }

  getAllLabor() {
    this.route = '/getLaborForDatePage';
    this.method = 'POST';
    this.typeAction = 'filterAll';
    let data = {
      idTypeLabor: 1,
      year: Number(localStorage.getItem(Constanst.STORAGE_DATA_ANIOCONSULT) ? localStorage.getItem(Constanst.STORAGE_DATA_ANIOCONSULT) : new Date().getFullYear()),
      month: Number(localStorage.getItem(Constanst.STORAGE_DATA_MONTHCONSULT) ? Number(localStorage.getItem(Constanst.STORAGE_DATA_MONTHCONSULT)) : (new Date().getMonth() + 1)),
      page: (this.paginator ? (this.paginator.pageIndex) : 0),
      pageSize: (this.paginator ? this.paginator.pageSize : 25)
    }

    this.apiCallService.call$(data, this.route, this.method, true, '', true)
      .pipe(takeUntil(this.destroy$)).subscribe(response => {

        if (response.status === Constanst.RESPONSE_STATUS_SUCCESS) {
          this.totalItemsPage = response.data.total;
          this.dataListManoDeObra = response.data.content;
          this.dataSourceFilters = new MatTableDataSource(this.dataListManoDeObra);
        } else {
          this.helperClassService.openDialogGeneric('25rem', true, Constanst.MSG_GENERIC_ERROR, false, true, false, '', '', '', Constanst.DIALOG_RESULT_ERROR);
        }
        this.apiCallService.hideSpinner();
      });
  }

  verAdicionales(row: ManoDeObra) {
    this.experiencia = row.experience;
    this.conocimientos = row.requisiteExpertise;
    this.tareas = row.task;
  }

  rowOver(row: ManoDeObra) {
    this.experiencia = row.experience;
    this.conocimientos = row.requisiteExpertise;
    this.tareas = row.task;
  }

  cleanInput() {
    this.experiencia = '';
    this.conocimientos = '';
    this.tareas = '';
  }

  resetPaginator(event: Event) {
    let filterValue = (event.target as HTMLInputElement).value.trim();
    if (filterValue == '') {
      this.paginator.pageIndex = 0;
      this.getAllLabor();
    }
  }

}
